import { render, staticRenderFns } from "./HeaderWrap.vue?vue&type=template&id=3155e967&scoped=true&"
import script from "./HeaderWrap.vue?vue&type=script&lang=js&"
export * from "./HeaderWrap.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWrap.vue?vue&type=style&index=0&id=3155e967&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3155e967",
  null
  
)

export default component.exports